import type { IdentifyTrait, UserTaxonomy } from '../contracts';
import { removePropertiesWithNullValues } from '../getPageTrackingData/getPageTrackingData';

export function mapTraitsToTaxonomy(traits?: IdentifyTrait): UserTaxonomy {
    if (!traits) return {};
    const {
        registered,
        registration_platform,
        signed_in_status,
        user_creation_date,
        user_id,
        user_uuid,
        about_me_status
    } = traits;
    return removePropertiesWithNullValues({
        registered,
        registration_platform,
        signed_in_status,
        user_creation_date,
        user_id,
        user_uuid,
        about_me_status
    });
}
